import React from 'react';
import {MainLayout} from 'components/layouts';
import FormCreateFair from 'components/fair/FormCreateFair.jsx';
import {Fairs} from 'base/api';
import {Link} from 'react-router-dom';

class AddFair extends React.Component {
  constructor(props, context) {
    super(props, context);

  }
  cb(response) {
    // Back to businesses list
    this.props.history.push('/fairs');
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fairs`}><i className='fa fa-chevron-left' />Quay về trang danh sách</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Thêm mới hội chợ</h1>
          </div>
          <FormCreateFair fnSubmit={Fairs.actions.add} cb={this.cb.bind(this)}/>
        </div>
      </MainLayout>
    );
  }
}

AddFair.contextTypes = {
  router: React.PropTypes.object
};

export default AddFair;


// WEBPACK FOOTER //
// ./pages/fair/Add.jsx